import styled from "styled-components";

const NotFoundWrapper=styled('div')`
    min-height:75vh;
    text-align:center;
    p{

        margin:auto;
        font-size:50px;
        padding-top:20px;


    }
    a{
        color: #337ab7 !important;
        text-decoration:none;
    }
  

`
export {
    NotFoundWrapper
}